exports.components = {
  "component---src-dynamic-pages-client-directus-page-tsx": () => import("./../../../src/dynamicPages/ClientDirectusPage.tsx" /* webpackChunkName: "component---src-dynamic-pages-client-directus-page-tsx" */),
  "component---src-dynamic-pages-server-directus-page-tsx": () => import("./../../../src/dynamicPages/ServerDirectusPage.tsx" /* webpackChunkName: "component---src-dynamic-pages-server-directus-page-tsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

